import { updateHandler } from "../utils";
/** Пользователи */
export var getUsersEndpoints = function (api) { return ({
    getUsers: {
        providesTags: ["getUsers"],
    },
    updateUser: {
        invalidatesTags: ["getUsers"],
        onQueryStarted: updateHandler("getUserById", "id", api),
    },
    deleteUser: {
        invalidatesTags: ["getUsers"],
    },
    getUserFavorites: {
        providesTags: ["getUserFavorites"],
    },
    addUserToFavorites: {
        invalidatesTags: ["getUserFavorites", "getUsers"],
        onQueryStarted: updateHandler("getUserById", "favoriteId", api, "id"),
    },
    removeUserFromFavorites: {
        invalidatesTags: ["getUserFavorites", "getUsers"],
        onQueryStarted: updateHandler("getUserById", "favoriteId", api, "id"),
    },
    getUserGames: {
        providesTags: ["getUserGames"],
    },
}); };
